/**
 * Author：tanyaohua 2020-04-28
 * discription: 产品管理 头条 企鹅 抖音统一的排序操作
 * 这里主要传了两个参数，分别是type：指的是渠道，用来自定义参数。第二个是选中的数组。
 */
'use strict';
angular.module('productManageMentResetAccountOrderModule', [])
    .controller('productManageMentResetAccountOrderCtrl', ['$scope', '$modalInstance', 'item', 'trsHttpService', '$validation', 'type', 'array', 'modalDialog', function($scope, $modalInstance, item, trsHttpService, $validation, type, array, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化值
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                indexNum: item.index,
                userName: '',
            };
            $scope.params = {
            };
        }

        /**
         * [initData description]初始化方法
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if (type === 'toutiao') {
                $scope.data.ObjId = item.CHANNELID;
                $scope.data.userName = item.CHNLNAME;
            } else if (type === 'qiehao'){
                $scope.data.userName = item.ACCOUNTNAME;
                $scope.data.accountId = item.KUAIBAOACCOUNTID;
            } else if (type === 'trill') {
                $scope.data.userName = item.ACCOUNTNAME;
                $scope.data.accountId = item.DOUYINACCOUNTID;
            } else if (type === 'weixin') {
                $scope.data.ObjId = item.CHANNELID;
                $scope.data.userName = item.CHNLDESC;
            } else if (type === 'kuaishou') {
                $scope.data.userName = item.ACCOUNTNAME;
                $scope.data.accountId = item.ACCOUNTID;
            }
        }

        /**
         * [dealParamsBeforeConfirm description]调整位置前处理参数
         *
         * @return  {[type]}  [return description]
         */
        function dealParamsBeforeConfirm() {
            // 这里获取到输入的值，如果大于了最大长度，则将这个排序位置到最后一个位置
            if ($scope.data.indexNum > array.length) {
                $scope.data.indexNum = array.length;
            }
            if (type === 'toutiao') {
                $scope.params = {
                    serviceid: 'mlf_toutiaoconfig',
                    methodname: 'resetAccountOrder',
                    ObjId: $scope.data.ObjId,
                    ObjType: '101',
                    Position: $scope.data.indexNum,
                };
            } else if (type === 'qiehao') {
                $scope.params = {
                    serviceid: 'mlf_kuaibaoaccount',
                    methodname: 'resetAccountOrder',
                    accountId: $scope.data.accountId,
                    orderNumber: $scope.data.indexNum,
                };
            } else if (type === 'trill') {
                $scope.params = {
                    serviceid: 'mlf_douyinconfig',
                    methodname: 'resetAccountOrder',
                    accountId: $scope.data.accountId,
                    orderNumber: $scope.data.indexNum,
                };
            } else if (type === 'weixin') {
                $scope.params = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'recordBaseChannel',
                    ObjId: $scope.data.ObjId,
                    ObjType: '101',
                    Position: $scope.data.indexNum,
                };
            } else if (type === 'kuaishou') {
                $scope.params = {
                    serviceid: 'mlf_kuaishouconfig',
                    methodname: 'resetAccountOrder',
                    AccountId: $scope.data.accountId,
                    orderNumber: $scope.data.indexNum,
                };
            }
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.sortForm.$pending = {};
            // if ($scope.data.indexNum > array.length) {
            //     $scope.data.indexNum = array.length;
            // }
            // dealParamsBeforeConfirm();
            // 这里拦截一下，如果排序前后是一致的，则不发请求
            // if (item.index == $scope.data.indexNum) {
            //     modalDialog.alertType('排序成功', '', 'success', false);
            //     $modalInstance.close('success');
            //     return;
            // }
            $validation.validate($scope.sortForm).success(function() {
                // if ($scope.data.indexNum > array.length) {
                //     modalDialog.alertType('排序失败', '所选位置超出最大长度', 'error', false);
                //     return;
                // }
                dealParamsBeforeConfirm();
                if (item.index == $scope.data.indexNum) {
                    modalDialog.alertType('排序成功', '', 'success', false);
                    $modalInstance.close('success');
                    return;
                }
                var params = $scope.params;
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post', true).then(function(data) {
                    $modalInstance.close('success');
                }, function(data) {
                    $modalInstance.close(data);
                });
            });
        };
    }]);
